<template>
    <div>
        <b-modal id="cancelar-import-beneficiario" centered body-class="body-class container cancelar-import-beneficiario-body" 
        no-stacking @hidden="$emit('close')">

            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            <p>Tem certeza que deseja cancelar a {{isValidating ? "validação" :"importação"}}?</p>
            <template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn" @click="hideModal">Não</b-button>
                <b-button pill class="btn-base primary-btn" @click="deletar">Sim</b-button>
            </template>	
        </b-modal>

        <b-modal id="cancelar-import-beneficiario-success" centered hide-footer @hidden="$emit('canceled')"
        header-class="cancelar-import-beneficiario-sub-header" body-class="cancelar-import-beneficiario-body">
            <DynamicIcon icon="check" :classString="'alert-exclamation'"/>
            <p>{{isValidating ? "Validação" :"Importação"}} cancelada com sucesso!</p>
            <div class="mt-4 mb-2">
                <b-button pill class="btn-base primary-btn btn-modal" @click="close">Ok</b-button>
            </div>
        </b-modal>
    </div>	
</template>

<script>
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
	name: "ModalCancelarImportacaoBeneficiario",
    components: {
		DynamicIcon 
	},
    data() {
        return {
            statusImportacao: 'VALIDATING'
        }
    },
    props : { importacaoId : Number, status: String },
    methods:{
        hideModal() {
            this.$bvModal.hide('cancelar-import-beneficiario')            
        },
        deletar(){
            BeneficiarioImportacaoResource.deletarImportacao(this.importacaoId, {showLoader: true})
            .then(() => {
                this.$bvModal.show('cancelar-import-beneficiario-success')
                this.$emit('canceled')
            })
        },
        close() {
            this.$bvModal.hide('cancelar-import-beneficiario-success')
        }
    },
    computed: {
        isValidating() {
            return this.statusImportacao == 'WAINTING_START' || this.statusImportacao == 'VALIDATING'
        }
    },
    watch: {
		status: function(newVal) {
			if(newVal) {
                this.statusImportacao = this.newVal
            }
		}
	},
    updated () {
        if(this.status) { 
            this.statusImportacao = this.status
        }
    }
}
</script>

<style>

.modal-title {
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 2.1px;
	color: #FF612B;
}

.cancelar-import-beneficiario-sub-header {
    padding-bottom: 5px !important;
}

.cancelar-import-beneficiario-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px !important;
    text-align: center;
}
</style>